<template>
  <div v-for="(item, index) in options" :key="item.id">
    <div
      class="radioButton-container"
      :class="{ flex: withLabel }"
      @click="handleSelect(item)"
    >
      <div
        class="radioButton"
        :class="{
          selected: selectedItems.includes(item.id),
        }"
      >
        <div class="radioButton-inner"></div>
      </div>
      <label :style="labelStyle" v-if="withLabel">
        {{ item.value }}
      </label>
    </div>
    <div class="hr" v-if="hr && index + 1 !== options.length">
      <Hr />
    </div>
  </div>
</template>

<script>
import { Hr } from "@n11/so-ui-components";

export default {
  name: "RadioButtonGroup",
  components: {
    Hr,
  },
  props: {
    withLabel: Boolean,
    labelStyle: Object,
    options: Array,
    defaultValue: {
      type: [String, Number],
    },
    hr: Boolean,
    multiSelect: {
      type: Boolean,
      default: false,
    },
    selected: Array,
  },
  data() {
    return {
      selectedItems: [],
      oldValue: null,
    };
  },
  methods: {
    handleSelect(item) {
      if (this.multiSelect) {
        if (this.selectedItems.includes(item.id)) {
          this.selectedItems = this.selectedItems.filter((a) => a !== item.id);
        } else {
          this.selectedItems.push(item.id);
        }
      } else {
        if (this.oldValue) {
          this.selectedItems = this.selectedItems.filter(
            (a) => a !== this.oldValue
          );
        }
        this.selectedItems.push(item.id);
        this.oldValue = item.id;
      }
      this.$emit("select", this.selectedItems);
    },
  },
  watch: {
    options() {
      this.selectedItems = [];
      if (this.selected) {
        this.selectedItems = this.selected;
      }
    },
  },
  emits: ["select"],
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.radioButton-container {
  display: flex;
  align-items: center;
  cursor: pointer;

  label {
    font-size: 14px;
    font-weight: 700;
    color: $gray-6;
    cursor: pointer;

    &.disabled {
      color: $gray-10 !important;
    }
  }
}

.hr {
  margin: 7px 20px 8px 30px;
}

.radioButton {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid $dark-gray-6;
  margin-right: 10px;

  &.selected {
    border-color: $colorN80;

    .radioButton-inner {
      background: $colorN80;
      border: 2px solid $colorN80;
    }
  }

  border-radius: 50%;

  &-inner {
    width: 60%;
    height: 60%;
    border-radius: 50%;
  }

  &.disabled {
    border: 1px solid $gray-10 !important;
  }
}
</style>
